import { Conversation } from "@twilio/conversations";

import { ACTION_CHANGE_ENGAGEMENT_PHASE, ACTION_UPDATE_CONVERSATION_STATE } from "../actionTypes";
import { AppState, EngagementPhase } from "../../definitions";
import { AnyDispatch } from "./definitions";
import { sessionDataHandler } from "../../../sessionDataHandler";

export const initConversationListener = (
    conversation: Conversation,
    dispatch: AnyDispatch,
    getState: () => AppState
) => {
    conversation.addListener("updated", ({ conversation: updatedConversation, updateReasons }) => {
        // we are listening only to a subset of events.
        if (updateReasons?.includes("state")) {
            dispatch({
                type: ACTION_UPDATE_CONVERSATION_STATE,
                payload: { conversationState: updatedConversation?.state?.current }
            });

            // If the conversation is closed we need to change the current phase
            if (updatedConversation.state?.current === "closed") {
                // Retrieve from the store the value of disablePostChatSurvey from the store
                const {
                    config: { disablePostChatSurvey }
                } = getState();

                // If disable post chat survey has true value, move to the thank you phase
                if (disablePostChatSurvey) {
                    // Clear the session storage
                    sessionDataHandler.clear();
                    dispatch({
                        type: ACTION_CHANGE_ENGAGEMENT_PHASE,
                        payload: {
                            currentPhase: EngagementPhase.ThankYouPhase
                        }
                    });
                } else {
                    dispatch({
                        type: ACTION_CHANGE_ENGAGEMENT_PHASE,
                        payload: {
                            currentPhase: EngagementPhase.PostChatSurvey
                        }
                    });
                }
            }
        }
    });
};
